export default __webpack_public_path__ + "static/media/zeus.36924c65.png";